module.exports = __webpack_public_path__ + "assets/img/DataF9.6e26bde9.png";